import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

interface RecordingUrlResponse {
  url: string | null
}

/**
 * Hook to fetch a presigned URL for a call recording.
 */
export function useRecordingUrl(callId: string | null, enabled = true) {
  const apiClient = useApiClient()

  return useQuery({
    queryKey: ['recording-url', callId],
    queryFn: async () => {
      return apiClient<RecordingUrlResponse>(`/recording-url?call_id=${callId}`)
    },
    enabled: !!callId && enabled,
    staleTime: 1000 * 60 * 30, // 30 minutes (signed URL valid for 1 hour)
    refetchOnWindowFocus: false,
  })
}